import { type JSX, type ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { buttonClass } from './ui/index.ts';

function AppErrorFallback({ resetError }: { resetError: () => void }): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-4 text-center">
        <h1 className="text-xl font-semibold tracking-tight">Something went wrong</h1>
        <p className="text-sm text-muted-foreground">
          The page encountered an unexpected problem. Please try again or contact support if the issue persists.
        </p>
        <div className="flex justify-center gap-3">
          <button
            type="button"
            onClick={resetError}
            className={buttonClass('primary')}
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => { window.location.href = '/'; }}
            className={buttonClass('secondary')}
          >
            Go to home
          </button>
        </div>
      </div>
    </div>
  );
}

export function AppErrorBoundary({ children }: { children: ReactNode }): JSX.Element {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => <AppErrorFallback resetError={resetError} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
